// Español de Latinoamérica

export default {
    'About': 'Acerca de',
    'Company': 'Empresa',
    'Contact': 'Contacto',
    'Email Address': 'Dirección de correo electrónico',
    'First Name': 'Nombre',
    'Get In Touch': 'Contáctanos',
    'Manage Cookies': 'Gestionar cookies',
    'Media Kit': 'Kit de prensa',
    'Newsroom': 'Sala de prensa',
    'Password': 'Contraseña',
    'Privacy Policy': 'Política de privacidad',
    'Related Case Studies': 'Ejemplos prácticos relacionados',
    'Related Resources': 'Recursos relacionados',
    'See Case Study': 'Ver ejemplo práctico',
    'Sign up': 'Suscribirse',
    'Submit': 'Enviar',
    'The Goal': 'La meta',
    'View All': 'Ver todos',
    'You are missing one or more requred fields': 'Te falta uno o más campos obligatorios',
    'All resources': 'Todos los recursos',
    'All case studies': 'Todos los casos de estudio',
    'All articles': 'Todos los artículos',
    'Do Not Share My Personal Information': 'No compartir mi información personal'
};
